// Loader
// Utilities
import * as React from "react";
/**
 * Context to provide the store loader to the components
 * This needs to be declared as "| null" to decouple the instantiation of the loader from the context
 */ export const StoreLoaderContext = React.createContext(null);
